module.exports = __webpack_public_path__ + "img/carbon2.0ea33b30.png";